import PixelHeader from './PixelHeader';

export default PixelHeader;
